// extracted by mini-css-extract-plugin
module.exports = {"TableNotes":"WireTableNotes__TableNotes___1rZk2","NoteSpan":"WireTableNotes__NoteSpan___olLZB"};